import { getNumber, lazyWithRetry, throw404Error } from '@tyro/core';
import { NoticeBoardIcon } from '@tyro/icons';
import { type NavObjectFunction, NavObjectType } from '@tyro/router/types';
import { getNoticeBoardDetails } from './api/notice-board';
const CreateNoticeTemplatePage = lazyWithRetry(() => import('./pages/create'));

const NoticeBoardPage = lazyWithRetry(() => import('./pages/index'));

export const getRoutes: NavObjectFunction = (t) => [
  {
    type: NavObjectType.Category,
    title: t('navigation:general.title'),
    children: [
      {
        type: NavObjectType.RootLink,
        path: '/notice-board',
        title: t('navigation:general.noticeBoards.title'),
        hasAccess: ({ permissions }) =>
          permissions.hasPermission('ps:1:communications:write_noticeboard'),
        icon: <NoticeBoardIcon />,
        children: [
          {
            type: NavObjectType.NonMenuLink,
            index: true,
            element: <NoticeBoardPage />,
          },
          {
            path: 'create',
            type: NavObjectType.NonMenuLink,
            element: <CreateNoticeTemplatePage />,
            loader: ({ request }) => {
              const { searchParams } = new URL(request.url);

              if (searchParams.has('createFromId')) {
                const id = getNumber(searchParams.get('createFromId'));
                if (!id) {
                  throw404Error();
                }
                return getNoticeBoardDetails({
                  admin: true,
                  archived:
                    request.url.includes('achieved') ||
                    searchParams.has('fromArchive'),
                  noticeIds: [id],
                });
              }

              return null;
            },
          },
          {
            path: 'edit/:id',
            type: NavObjectType.NonMenuLink,
            element: <CreateNoticeTemplatePage />,
            loader: ({ params }) => {
              const id = getNumber(params.id);

              if (!id) {
                throw404Error();
              }
              return getNoticeBoardDetails({
                admin: true,
                archived: false,
                noticeIds: [id],
              });
            },
          },
          {
            path: 'edit/achieved/:id',
            type: NavObjectType.NonMenuLink,
            element: <CreateNoticeTemplatePage />,
            loader: ({ params }) => {
              const id = getNumber(params.id);

              if (!id) {
                throw404Error();
              }
              return getNoticeBoardDetails({
                admin: true,
                archived: true,
                noticeIds: [id],
              });
            },
          },
        ],
      },
    ],
  },
];
